import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.ConsentManagementEmailAddress
 * 
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage
 */
export class ConsentManagementEmailAddressApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ConsentManagementEmailAddressApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected email: string;
	/**
	 * Description: Wert des Kanal (Email oder Telefonnummer)
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: Wert des Kanal (Email oder Telefonnummer)
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected authorized: boolean;
	/**
	 * Description: dem Kanal wurde zugestimmt
	 * APIL Type: boolean
	 */
	get Authorized(): boolean {
		return this.authorized;
	}

	/**
	 * Description: dem Kanal wurde zugestimmt
	 * APIL Type: boolean
	 */
	set Authorized(value: boolean) {
		this.authorized = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ConsentManagementEmailAddressApi {
		return AppUtils.Helper.createFromMap(dataObject, ConsentManagementEmailAddressApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Email = this.email;
		result.Authorized = this.authorized;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}